import { useMemo } from "react";
import { userConfiguration } from "client_legacy/ndaw/workspaceAbilitiesStatusProvider";
import { UserLicense } from "client/Api/FeaturePackages/featurePackageManagement";
import {
	EnvironmentFeature,
	getRequiredUserLicenseForEnvironmentFeature
} from "client/Features/FeaturePackages/misc";

export function useHasRequiredLicenseForFeature(
	environmentFeature: EnvironmentFeature
): boolean {
	const result = useMemo(
		(): boolean => {
			const { userLicense } = userConfiguration();
			const requiredLicense: UserLicense = getRequiredUserLicenseForEnvironmentFeature(
				environmentFeature
			);

			return doesUserLicenseSatisfyRequiredLicense(userLicense, requiredLicense);

		},
		[environmentFeature]
	);

	return result;
}

const USER_LICENSES_WITH_PRIORITY_ORDER: readonly UserLicense[] = [UserLicense.Simplify, UserLicense.Connect];

export function doesUserLicenseSatisfyRequiredLicense(
	userLicense: UserLicense,
	requiredLicense: UserLicense
): boolean {
	const requiredLicenseIndex: number = USER_LICENSES_WITH_PRIORITY_ORDER.indexOf(requiredLicense);
	const userLicenseIndex: number = USER_LICENSES_WITH_PRIORITY_ORDER.indexOf(userLicense);

	if (requiredLicenseIndex === -1) {
		throw new Error("Required license is not supported");
	}

	if (userLicenseIndex === -1) {
		throw new Error("User license is not supported");
	}

	return userLicenseIndex >= requiredLicenseIndex;
}